import { Component } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateFactory } from "@shared/modules/translate/factory/translate.factory";
import { ValidateDocumentService } from "@shared/services/validate-document/validate-document.service";
import { AfTranslatePipe } from "@shared/modules/translate/pipe/af-translate.pipe";
import { AfTranslateDirective } from "../../modules/translate/directive/af-translate.directive";
import { FieldTypeSwitchComponent } from "../field-type-switch/field-type-switch.component";
import { FieldTypeTextSimpleComponent } from "../field-type-text/field-type-text-simple/field-type-text-simple.component";
import { ModalServiceService } from "@shared/services/modal-service/modal-service.service";
import { NgClass } from "@angular/common";

@Component({
    selector: 'export-modal',
    templateUrl: './export-modal.component.html',
    standalone: true,
    imports: [NgClass, FieldTypeTextSimpleComponent, FieldTypeSwitchComponent, AfTranslateDirective, AfTranslatePipe]
})
export class ExportModalComponent {
  configuration: any = this.dialogConfig.data;
  exportModal: any = {
    title: this.configuration.title?this.configuration.title:this.translate.instant('common.export-excel'),
    filenameInput: {
      required: true,
      label: this.translate.instant('export-modal.input-label')
    }
  }
  constructor(private translate:AfTranslateFactory,
    private validateDocumentService: ValidateDocumentService,
    private modalService: ModalServiceService,
    private dialogRef: DynamicDialogRef<ExportModalComponent>,
    private dialogConfig: DynamicDialogConfig){}

  setFilename(e:any) {
    this.exportModal.filenameInput.value = e.newValue;
  }

  exportAction(){
    if(this.validateForm()){
      this.handleAccept();
    }else if(this.configuration.hasPrevious){
      this.modalService.errorModal({ text: this.translate.instant('export-modal.error-validation') });
    }
  }

  validateForm() {
    delete this.exportModal.filenameInput.errorText;
    let filenameInputValue:any = this.exportModal.filenameInput.value;
    if (filenameInputValue == null || filenameInputValue.trim() == '') {
      this.exportModal.filenameInput.errorText = this.translate.instant('export-modal.error-message.empty-name')
    } else if(!(this.validateDocumentService.correctCharacters(filenameInputValue))){
      this.exportModal.filenameInput.errorText = this.translate.instant('rename-modal.incorrect-characters');
    } else if(this.configuration.list?.length){
        for (const elementList of this.configuration.list) {
          let elementName = elementList.name;
          if (elementName.substring(0, elementName.lastIndexOf('.')).toLowerCase() === this.exportModal.filenameInput.value.toLowerCase() && elementList.extension.toLowerCase().indexOf(this.configuration.extension.toLowerCase()) !== -1) {
            this.exportModal.filenameInput.errorText = this.translate.instant('export-modal.document-name-exist');
            break;
          }
        }
    }
    this.exportModal.filenameInput.error = this.exportModal.filenameInput.errorText?true:false;
    return !this.exportModal.filenameInput.error;
  }

  handleAccept() {
    this.dialogRef.close({
      result:'ok',
      filename: this.exportModal.filenameInput.value,
      openFile: this.exportModal.openFile,
      downloadFile: this.exportModal.downloadFile
    });
  }

  handleDismiss(type: string = 'cancel') {
    this.dialogRef.close({result:type});
  }
}
